import React from "react"
import autobind from "class-autobind"
import AccountStore from "../../stores/AccountStore"
import { SelectField, MenuItem } from "material-ui"
import ChooseHierarchyChip from "../hierarchy/choose_hierarchy/ChooseHierarchyChip"
import * as userHelper from "../../helpers/userHelper"
import * as permissionHelper from "../../helpers/permissionHelper"
import strings from "../../localization/strings"
interface IProps {
    organizationHierarchyId: string
    userRoleId: string
    nonCheckValidate?: boolean
}
interface IState {
    // do not change variable name
    organizationHierarchyId: string
    errorOrganizationHierarchyId: string
    isAdmin: boolean
    userRoleId: string
    errorUserRoleId: string
}

export default class AccountUserOrganizationHierarchyAndUserRole extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props)
        this.state = {
            organizationHierarchyId: props.organizationHierarchyId,
            errorOrganizationHierarchyId: "",
            isAdmin: props.userRoleId ? permissionHelper.isAccountAdmin(props.userRoleId) : false,
            userRoleId: props.userRoleId,
            errorUserRoleId: ""
        }
        autobind(this)
    }

    componentDidMount() {
        this.checkValidate(this.props.nonCheckValidate)
    }

    componentWillReceiveProps(nextProps: IProps) {
        this.props.nonCheckValidate !== nextProps.nonCheckValidate &&
            this.checkValidate(nextProps.nonCheckValidate)
    }

    checkValidate(nonCheckValidate) {
        if (nonCheckValidate) {
            this.setState({ errorOrganizationHierarchyId: "", errorUserRoleId: "" })
        }
        else {
            if (AccountStore.getExplicitAccountUserHierarchyAssignment() && !this.state.isAdmin && !this.state.organizationHierarchyId) {
                this.setState({ errorOrganizationHierarchyId: strings.Only_account_admin_can_have_root_level })
            } else {
                this.setState({ errorOrganizationHierarchyId: "" })
            }

            if (!this.state.userRoleId) {
                this.setState({ errorUserRoleId: strings.This_field_is_required })
            } else {
                this.setState({ errorUserRoleId: "" })
            }
        }
    }

    render() {
        return (
            <div>
                <div style={{ display: "flex", alignItems: "center" }}>
                    <div style={{ width: 260 }}>{strings.Organization_Hierarchy}</div>
                    <ChooseHierarchyChip
                        getCustomNoAccessErrorStr={organizationHierarchy =>
                            userHelper.getSupervisorAssignValidationForOrganizationHierarchy(organizationHierarchy ? organizationHierarchy.Id : null, this.state.isAdmin) ?
                                null :
                                strings.This_hierarchy_item_cant_be_assigned
                        }
                        chipLabel={""}
                        hierarchyItemId={this.state.organizationHierarchyId}
                        handleSelectHierarchy={organizationHierarchyId => this.setState({ organizationHierarchyId }, () =>
                            this.checkValidate(this.props.nonCheckValidate)
                        )}
                        errorChipText={this.state.errorOrganizationHierarchyId}
                    />
                </div>
                <div style={{ display: "flex", alignItems: "center" }}>
                    <div style={{ width: 260 }}>{strings.User_Role}</div>
                    <SelectField
                        data-intercom-target={"AccountUsers-Select-UserRole"}
                        value={this.state.userRoleId}
                        onChange={(event, index, userRoleId) => this.setState({ userRoleId, isAdmin: permissionHelper.isAccountAdmin(userRoleId) }, () =>
                            this.checkValidate(this.props.nonCheckValidate)
                        )}
                        errorText={this.state.errorUserRoleId}
                        errorStyle={{ position: "absolute", bottom: -10 }}
                    >
                        {AccountStore.getCurrentAccountSettings().UserRoles.map((userRole, index) =>
                            <MenuItem value={userRole.Id} key={index} primaryText={userRole.Type} />
                        )}
                    </SelectField>
                </div>
            </div>
        )
    }
}